import { CalendarWeek, ClockHistory, LockFill } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import { Typography } from 'antd';

import BaseCard from '@/components/shared/BaseCard';
import Shelf from '@/components/shared/Shelf';
import { getCdnUrl } from '@/helpers';
import { enStatus } from '@/interfaces/course';
import ShortInfo from '@/pages/MyCourses/Card/ShortInfo';
import { useGetCoursesQuery } from '@/services/course';
import styled, { StyledProp } from '@/styled';

const iconMapper: Record<string, any> = {
  [enStatus.EXPIRED]: <ClockHistory size={48} />,
  [enStatus.BLOCKED]: <LockFill size={48} />,
  [enStatus.NOT_RELEASED]: <CalendarWeek size={48} />,
  [enStatus.NOT_PURCHASED]: <LockFill size={48} />
};

const MyCoursesShelf = ({ ...rest }: StyledProp) => {
  const navigate = useNavigate();
  const { data, isFetching } = useGetCoursesQuery({ page: 1, size: 24 });

  if (!data?.data?.length && !isFetching) {
    return null;
  }

  return (
    <Shelf
      shelfProps={{
        isFetching
      }}
      title={
        <>
          <Typography.Title level={4} ellipsis>
            Meus cursos
          </Typography.Title>
          <Typography.Link underline onClick={() => navigate('/cursos')} rel='noopener noreferrer'>
            Ver todos
          </Typography.Link>
        </>
      }
      carouselProps={{ slidesToShow: 4 }}
      {...rest}
    >
      <>
        {data?.data?.map(course => (
          <swiper-slide key={course.id}>
            <BaseCard
              image={{
                aspect: '16:9',
                src: getCdnUrl(course.course_newcard_background, course.image, course.old_image)
              }}
              onClick={() => navigate(`/curso/${course.hash}`)}
              internalSpace={16}
              extraContent={<div className='status'>{iconMapper[course.status]}</div>}
            >
              <ShortInfo course={course} showStatus />
            </BaseCard>
          </swiper-slide>
        ))}
      </>
    </Shelf>
  );
};

export default styled(MyCoursesShelf)`
  .carouselNavigator-container {
    min-height: 100% !important;
  }

  ${({ theme }) => theme.breakpoints.down('xlg')} {
    .space {
      flex-wrap: wrap;
      justify-content: flex-start !important;
    }
  }

  .status {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: calc(100% - 105px);
    top: 0px;
    left: 0;
    z-index: 2;

    svg {
      color: ${({ theme }) => theme.colorIcon};
      filter: drop-shadow(0px 0px 16px rgb(0 0 0 / 1));
    }
  }

  .base-card-data {
    .ant-typography {
      margin-bottom: 0;
      color: ${({ theme }) => theme.colorTextSecondary};
    }
  }
`;
